import { render, staticRenderFns } from "./nurseDetail.vue?vue&type=template&id=02462780&scoped=true&"
import script from "./nurseDetail.vue?vue&type=script&lang=js&"
export * from "./nurseDetail.vue?vue&type=script&lang=js&"
import style0 from "./nurseDetail.vue?vue&type=style&index=0&id=02462780&lang=scss&scoped=true&"
import style1 from "./nurseDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02462780",
  null
  
)

export default component.exports